<div
  class="wrapper"
  [class.ghost]="isLoading()"
  [class.square]="shape() === 'square'"
  [class.with-border]="withBorder()"
  [style.width]="size"
  [style.height]="size"
  [style.border-radius]="shape() === 'square' ? borderRadius() : '50%'">
  @if (!isLoading()) {
    @if (state().imageUrl()) {
      <div
        class="avatar"
        aria-hidden="true"
        [style.border-radius]="shape() === 'square' ? borderRadius() : '50%'"
        [lazyLoad]="state().imageUrl()"
        (onStateChange)="lazyLoadOnStatechange($event)"></div>
    } @else {
      @if (name) {
        <div
          class="avatar"
          [style.border-radius]="shape() === 'square' ? borderRadius() : '50%'"
          [style.background-color]="initialsBgColor">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            x="0"
            y="0"
            viewBox="0 0 40 40"
            focusable="false">
            <style>
              @import url('https://fonts.googleapis.com/css?family=Roboto:500');
            </style>
            <text
              [style.fill]="initialsTextColor"
              [attr.x]="'50%'"
              [attr.y]="'50%'"
              font-family="Roboto"
              font-size="14px"
              font-weight="500"
              letter-spacing="1"
              dominant-baseline="central"
              text-anchor="middle"
              focusable="false">
              {{ initials }}
            </text>
          </svg>
        </div>
      }
    }

    <div
      class="avatar default"
      [style.border-radius]="shape() === 'square' ? borderRadius() : '50%'">
      <accredible-icon icon="user1" [style.font-size]="avatarDefaultFontSize" />
    </div>
  } @else {
    <div class="avatar" [style.border-radius]="shape() === 'square' ? borderRadius() : '50%'"></div>
  }
</div>
